/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const invoiceSettingsDataSchema = z.object({
	externalInvoicing: z.boolean(),
	canPayViaInvoice: z.boolean(),
	isDemo: z.boolean(),
	careerSiteEnabled: z.boolean(),
})

export type InvoiceSettingsDataSchema = z.infer<typeof invoiceSettingsDataSchema>
